import React, { useEffect, useState } from 'react';
import { Table, Tag, Typography, Spin } from 'antd';
import { API_ENDPOINTS } from '../utils/apiConfig';

const { Title } = Typography;

interface Category {
  _id: string;
  name: string;
  isActive: boolean;
}

const CategoryTab: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(API_ENDPOINTS.CATEGORIES_ALL, {
          headers: { 'Authorization': `Bearer ${token}` },
        });
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const columns = [
    {
      title: 'Category Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Active',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => (
        <Tag color={isActive ? 'green' : 'red'}>{isActive ? 'Active' : 'Inactive'}</Tag>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Category Management</Title>
      <Spin spinning={loading}>
        <Table
          dataSource={categories}
          columns={columns}
          rowKey="_id"
          pagination={false}
        />
      </Spin>
    </div>
  );
};

export default CategoryTab; 